import { ListaReuniaoComMesAno } from '../../../../services/requests';
import { tituloFormatado } from '../../../../utils/meetingHelpers';

import { MeetingCard } from '../MeetingCard';

import { Divider, Title } from './styles';

interface SectionMeetingCardProps {
  listagemReunioes: ListaReuniaoComMesAno;
  isPast?: boolean;
  checked?: boolean;
}

export const SectionMeetingCard = ({
  listagemReunioes,
  isPast,
  checked,
}: SectionMeetingCardProps) => {
  let meetingsAvailable = [];

  if (checked) {
    meetingsAvailable = listagemReunioes?.meetings.filter(
      m => m?.canceled_at !== null,
    );
  } else {
    meetingsAvailable = listagemReunioes?.meetings.filter(
      m => m?.canceled_at === null,
    );
  }

  return meetingsAvailable?.length > 0 ? (
    <>
      <Divider className="month-divider">
        <Title>{tituloFormatado(listagemReunioes?.data)}</Title>
      </Divider>

      {meetingsAvailable?.map(m => (
        <MeetingCard key={m?.id} meeting={m} isPast={isPast} />
      ))}
    </>
  ) : null;
};
